import React, { useEffect, useRef, useState } from "react";
import videos from "./getVideos";
import "./VideoFeed.css";
import { Link } from "react-router-dom";
import { FaInfoCircle } from "react-icons/fa"; // optional, install react-icons

// inside your VideoFeed JSX, maybe near the top

function getRandomVideo() {
  return videos[Math.floor(Math.random() * videos.length)];
}

const VideoFeed = () => {
  const [feed, setFeed] = useState([
    { id: 1, src: getRandomVideo() },
    { id: 2, src: getRandomVideo() },
  ]);

  const [globalMuted, setGlobalMuted] = useState(true);
  const [timer, setTimer] = useState(0); // seconds
  const videoRefs = useRef([]);
  const sentinelRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false); // For currently visible video
  const currentVideoIndex = useRef(0); // Track currently visible video

  const timerStarted = useRef(false);

  // Auto-play active and track current video
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          const index = video.dataset.index;
          if (entry.isIntersecting) {
            currentVideoIndex.current = index;
            video.muted = globalMuted;
            video.play()
              .then(() => {
                setIsPlaying(true);
                if (!timerStarted.current) {
                  setTimer(0);
                  timerStarted.current = true;
                }
              })
              .catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.75 }
    );

    videoRefs.current.forEach((v) => v && observer.observe(v));
    return () => observer.disconnect();
  }, [feed, globalMuted]);

  // Infinite scroll
  useEffect(() => {
    const sObs = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setFeed((prev) => [
            ...prev,
            { id: prev.length + 1, src: getRandomVideo() },
          ]);
        }
      },
      { rootMargin: "200px" }
    );

    if (sentinelRef.current) sObs.observe(sentinelRef.current);
    return () => sObs.disconnect();
  }, []);

  // Timer logic (global)
  useEffect(() => {
    const interval = setInterval(() => setTimer((prev) => prev + 1), 1000);
    return () => clearInterval(interval);
  }, []);

  const formatTime = (sec) => {
    const minutes = Math.floor(sec / 60);
    const seconds = sec % 60;
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  const toggleMute = () => {
    const newState = !globalMuted;
    setGlobalMuted(newState);
    videoRefs.current.forEach((v) => v && (v.muted = newState));
  };

  const togglePlayPause = () => {
    const video = videoRefs.current[currentVideoIndex.current];
    if (!video) return;

    if (video.paused) {
      video.play().catch(() => {});
      setIsPlaying(true);
    } else {
      video.pause();
      setIsPlaying(false);
    }
  };

  const goToNext = (index) => {
    const next = videoRefs.current[index + 1];
    if (next) next.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="feed">
      {/* Global Timer */}
      <div className="global-timer">
        {formatTime(timer)}
        {/* Play/Pause button controls video, not timer */}
        <button onClick={togglePlayPause}>
          {isPlaying ? "⏸️" : "▶️"}
        </button>
        
      </div>

      {feed.map((item, index) => (
        <div key={item.id} className="page">
          <div className="video-container premium-frame">
            <video
              ref={(el) => (videoRefs.current[index] = el)}
              className="video"
              data-index={index}
              src={item.src}
              playsInline
              muted={globalMuted}
              onClick={toggleMute}
              onEnded={() => goToNext(index)}
            />

            {/* Sound button */}
            <div className="sound-btn" onClick={toggleMute}>
              {globalMuted ? "🔇" : "🔊"}
            </div>

            {/* Bottom caption */}
          <a
  href="https://almondsoftwares.in"
  target="_blank"
  rel="noopener noreferrer"
  className="bottom-info btn-almond"
>
  <h3>@aclips</h3>
  <p>Developed by almondsoftwares.in </p>
</a>
{/* Left Control Bar */}
<div className="left-controls">
  <Link to="/about" className="control-btn about-btn" title="About">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="16" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12" y2="8" />
    </svg>
  </Link>
</div>


            {/* Right controls */}
            <div className="right-controls">
                
              <div
                className={`control-btn like-btn ${item.liked ? "liked" : ""}`}
                onClick={() => {
                  setFeed((prev) =>
                    prev.map((v, i) =>
                      i === index ? { ...v, liked: !v.liked } : v
                    )
                  );
                  const burst = document.createElement("div");
                  burst.className = "like-burst";
                  videoRefs.current[index].parentElement.appendChild(burst);
                  setTimeout(() => burst.remove(), 600);
                }}
              >
                {item.liked ? "❤️" : "💛"}
              </div>
            </div>
          </div>
        </div>
      ))}

      <div ref={sentinelRef} className="sentinel"></div>
    </div>
  );
};

export default VideoFeed;
